import TfaResetProcess from "../pages/auth/TfaResetProcess";
var routes = [{
  path: '/',
  name: 'publicRoot',
  component: function component() {
    return import('layouts/DefaultPublic');
  },
  meta: {
    auth: false,
    title: 'OzeIT | Home'
  },
  children: [{
    name: 'publicHome',
    path: '/home',
    component: function component() {
      return import('pages/Home');
    },
    meta: {
      title: 'OzeIT | Home'
    }
  },
  // signin
  {
    name: 'signin',
    path: '/signin',
    component: function component() {
      return import('pages/auth/SignIn');
    },
    meta: {
      title: 'OzeIT | Sign In'
    }
  },
  // verify email via invite
  {
    name: 'verifyemail-invite',
    path: '/verifyinvite/:code?',
    component: function component() {
      return import('pages/auth/VerifyEmailInvite');
    },
    meta: {
      title: 'OzeIT | Verify Email'
    }
  },
  // password reset request
  {
    name: 'password-reset-request',
    path: '/password/reset/request',
    component: function component() {
      return import('pages/auth/PasswordResetRequest');
    },
    meta: {
      title: 'OzeIT | Password Reset Request'
    }
  },
  // password reset process
  {
    name: 'password-reset-process',
    path: '/password/reset/process/:code',
    component: function component() {
      return import('pages/auth/PasswordResetProcess');
    },
    meta: {
      title: 'OzeIT | Password Reset Process'
    }
  },
  /*
  TFA
  */
  // setup
  {
    name: 'tfa-setup',
    path: '/tfa/setup',
    component: function component() {
      return import('pages/auth/TfaSetup');
    },
    meta: {
      title: 'OzeIT | Two-Factor Authentication Setup',
      auth: true
    }
  },
  // google
  {
    name: 'tfa-google',
    path: '/tfa/google',
    component: function component() {
      return import('pages/auth/TfaGoogle');
    },
    meta: {
      title: 'OzeIT | Two-Factor Authentication',
      auth: true
    }
  },
  // sms
  {
    name: 'tfa-sms',
    path: '/tfa/sms',
    component: function component() {
      return import('pages/auth/TfaSms');
    },
    meta: {
      title: 'OzeIT | Two-Factor Authentication',
      auth: true
    }
  },
  // reset
  {
    name: 'tfa-reset-process',
    path: '/tfa/reset/process/:code',
    component: TfaResetProcess,
    meta: {
      title: 'OzeIT | Two-Factor Authentication Reset'
    }
  },
  /*
  ERROR 401
  */
  {
    name: 'error401',
    path: '/error401',
    component: function component() {
      return import('pages/Error401');
    },
    meta: {
      title: 'OzeIT | Permission Error'
    }
  }]
}, {
  path: '/app',
  component: function component() {
    return import('layouts/Default');
  },
  meta: {
    auth: true
  },
  children: [
  /*
   DASHBOARD
   */
  {
    name: 'dashboard',
    path: '/dashboard',
    component: function component() {
      return import('pages/Dashboard');
    },
    meta: {
      auth: true,
      title: 'OzeIT | Dashboard'
    }
  },
  /*
   PROFILE
   */
  {
    name: 'profile',
    path: '/profile',
    component: function component() {
      return import('pages/auth/Profile');
    },
    meta: {
      auth: true,
      title: 'OzeIT | Profile'
    }
  },
  /*
  TEAMS
  */
  // team setup
  {
    name: 'team-setup',
    path: '/team/setup',
    component: function component() {
      return import('pages/auth/TeamSetup');
    },
    meta: {
      title: 'OzeIT | Team Setup',
      auth: true
    }
  },
  // home
  {
    name: 'team-home',
    path: '/team',
    component: function component() {
      return import('pages/team/TeamHome');
    },
    meta: {
      auth: true,
      title: 'OzeIT | Team'
    },
    children: [
    // users
    {
      name: 'team-users',
      path: '/team/users',
      component: function component() {
        return import('pages/team/TeamUserManagement');
      },
      meta: {
        auth: true,
        title: 'OzeIT | Users'
      }
    },
    // notification
    {
      name: 'team-notifications',
      path: '/team/notifications',
      component: function component() {
        return import('pages/team/TeamNotifications');
      },
      meta: {
        auth: true,
        title: 'OzeIT | Notifications'
      }
    },
    // sms
    {
      name: 'team-sms',
      path: '/team/sms',
      component: function component() {
        return import('pages/team/TeamSms');
      },
      meta: {
        auth: true,
        title: 'OzeIT | SMS'
      }
    }]
  },
  /*
   TICKETS
   */
  {
    name: 'ticket-edit',
    path: '/ticket/:id',
    component: function component() {
      return import('pages/ticket/TicketEdit');
    },
    meta: {
      auth: true,
      title: 'OzeIT | Tickets'
    }
  }]
},
/*
QUOTES PUBLIC
*/
{
  name: 'quote-view',
  path: '/q/:id/:preview?',
  component: function component() {
    return import('pages/quote/QuoteView');
  },
  meta: {
    title: 'OzeIT | View Quote'
  }
},
/*
PROPOSALS PUBLIC
*/
{
  name: 'proposal-view',
  path: '/p/:id',
  component: function component() {
    return import('pages/proposal/ProposalView');
  },
  meta: {
    title: 'OzeIT | View Proposal'
  }
},
/*
FORM SCHEMA PUBLIC
*/
{
  name: 'formschema-view',
  path: '/f/:id',
  component: function component() {
    return import('pages/teamformschema/TeamFormSchemaView');
  },
  meta: {
    title: 'OzeIT | Forms'
  }
},
/*
TEAM ACCESS REQUEST PUBLIC
*/
{
  name: 'teamaccessrequest-view',
  path: '/tar/verify/:id',
  component: function component() {
    return import('pages/teamaccessrequest/TeamAccessRequestView');
  },
  meta: {
    title: 'OzeIT | Access Request'
  }
},
/*
 TEAM ONBOARDING REQUEST PUBLIC
 */
{
  name: 'teamonboarding-view',
  path: '/to/onboarding/:id',
  component: function component() {
    return import('pages/teamonboarding/TeamOnboardingView');
  },
  meta: {
    title: 'OzeIT | Onboarding'
  }
},
/*
USER TASK CONFIRM PUBLIC
*/
{
  name: 'usertask-confirm',
  path: '/ut/confirm/:id',
  component: function component() {
    return import('pages/usertask/UserTaskConfirm');
  },
  meta: {
    title: 'OzeIT | Task Acceptance'
  }
},
/*
TEAM PORTING USER
*/
{
  name: 'teamportinguser-view',
  path: '/tpu/:id',
  component: function component() {
    return import('pages/teamportinguser/TeamPortingUserView');
  },
  meta: {
    title: 'OzeIT | Team Porting User'
  }
},
/*
TEAM CAMPAIGN
*/
{
  name: 'teamcampaign-view',
  path: '/tc/:id',
  component: function component() {
    return import('pages/teamcampaign/TeamCampaignEditPage');
  },
  meta: {
    title: 'OzeIT | Campaigns'
  }
},
/*
ERROR `404`
*/
{
  name: 'error404',
  path: '*',
  component: function component() {
    return import('pages/Error404');
  },
  meta: {
    title: 'OzeIT | Page Not Found'
  }
}];
export default routes;